import D3VerticalStacked from './d3VerticalStacked'
export default D3VerticalStacked
